/** InsCoder WANG.J 2026-07-16 B + Compatibility accordion state helper **/
if (!customElements.get('compatibility-table')) {
  customElements.define(
    'compatibility-table',
    class CompatibilityTable extends HTMLElement {
      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.cust-compatibility-table__details');
        this.detailsElements.forEach((details) => {
          this.syncItemState(details);
          details.addEventListener('toggle', () => this.syncItemState(details));
        });

        this.wirePopupTrigger();
      }

      syncItemState(details) {
        details.closest('.cust-compatibility-table__item')?.classList.toggle('is-open', details.open);
      }

      wirePopupTrigger() {
        const section = this.closest('.section');
        if (!section) return;

        const trigger = section.querySelector('.cust-compatibility-popup-link');
        if (!trigger || trigger.dataset.popupTriggerBound === 'true') return;

        const modalId = trigger.dataset.popupModal;
        const modal = modalId ? document.getElementById(modalId) : null;
        if (!modal) return;

        trigger.dataset.popupTriggerBound = 'true';

        const openModal = (event) => {
          if (event) event.preventDefault();
          modal.show(trigger);
        };

        trigger.addEventListener('click', openModal);
        trigger.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          openModal(event);
        });

        modal.addEventListener('toggle', () => {
          trigger.setAttribute('aria-expanded', modal.hasAttribute('open') ? 'true' : 'false');
        });
      }
    }
  );
}
/** InsCoder WANG.J 2026-07-16 E + Compatibility accordion state helper **/

/** InsCoder WANG.J 2026-08-21 B + Wire description popup when no <compatibility-table> is present **/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cust-compatibility-popup-link').forEach((trigger) => {
    if (trigger.dataset.popupTriggerBound === 'true') return;
    if (trigger.closest('compatibility-table')) return;

    const modalId = trigger.dataset.popupModal;
    const modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return;

    trigger.dataset.popupTriggerBound = 'true';

    const openModal = (event) => {
      if (event) event.preventDefault();
      modal.show(trigger);
    };

    trigger.addEventListener('click', openModal);
    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      openModal(event);
    });

    modal.addEventListener('toggle', () => {
      trigger.setAttribute('aria-expanded', modal.hasAttribute('open') ? 'true' : 'false');
    });
  });
});
/** InsCoder WANG.J 2026-08-21 E + Wire description popup when no <compatibility-table> is present **/
